import { Waveform } from '../domain/segments';

export function getMaxWidthForWaveform(segments: readonly { waveform: Waveform }[]) {
  return (
    segments.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.waveform.length;
    }, 0) -
    segments.length * 2
  );
}
